<template>
  <div class="astroCalendar" id="astroCalendar">
    <div class="astroCalendar__header">
      <h2 class="st_title">共时历</h2>
    </div>
    <div class="astroCalendar__main" v-if="selectedDate">
      <div class="astroCalendar__main__nav">
        <div class="astroCalendar__main__nav__prev" @click="preMonth()">
          <img
            src="@/assets/共時曆/pre.svg"
            v-if="
              moment(this.selectedDate).isBefore(moment('2025-02-01'), 'month')
            "
          />
          <img src="@/assets/共時曆/pre_active.svg" v-else />
        </div>
        <div class="astroCalendar__main__nav__date">
          {{ calendarMonthTitle }}
        </div>
        <div class="astroCalendar__main__nav__next" @click="nextMonth()">
          <img
            src="@/assets/共時曆/next.svg"
            v-if="
              moment(this.selectedDate).isAfter(moment('2026-11-01'), 'month')
            "
          />
          <img src="@/assets/共時曆/next_active.svg" v-else />
        </div>
      </div>
      <Tab
        class="astroCalendar__main__tab"
        :tabList="tabList"
        :current="showType"
        @setActiveTab="changeTabHandler"
      />

      <!-- Tab 1 日曆 -->
      <div
        class="astroCalendar__main__calendar"
        v-show="showType === 'calendar'"
      >
        <!-- 將高度改為綁定，並在下方加入展開/收合按鈕 -->
        <div id="calendar" :class="{ calendarIsCollapsed: isCollapsed }"></div>

        <div class="astroCalendar__main__calendar__tips" v-show="!isCollapsed">
          *℞：代表逆行 <span class="ml-6">→：代表进入</span>
        </div>
        <div
          class="astroCalendar__main__calendar__toggle"
          @click="toggleCalendarCollapse"
        >
          <div class="astroCalendar__main__calendar__toggle__text">
            {{ isCollapsed ? "點擊展開" : "點擊收合" }}
          </div>
          <div
            class="astroCalendar__main__calendar__toggle__img"
            :class="{ calendarIsCollapsed: isCollapsed }"
          >
            <img src="@/assets/共時曆/共時歷收合.svg" alt="" />
          </div>
        </div>
        <div class="astroCalendar__main__calendar__divider"></div>

        <!-- 解讀區塊 -->
        <div class="astroCalendarDetail">
          <div class="astroCalendarDetail__picArea">
            <img :src="topicImg" alt="" />
          </div>

          <div class="astroCalendarDetail__date">
            {{ moment(selectedDate).format("MM/DD") }}
            <span>{{ moment(selectedDate).format("ddd") }}</span>
          </div>

          <div class="astroCalendarDetail__highlight">
            ★ {{ interpretation.Highlight }}
          </div>

          <div class="astroCalendarDetail__themes">
            <div
              class="astroCalendarDetail__themes__item"
              v-for="(theme, index) in interpretation.Themes"
              :key="index"
            >
              {{ theme }}
            </div>
          </div>

          <div class="astroCalendarDetail__teacher">
            <div class="teacher__header">
              <div class="teacher__header__pic">
                <img src="../../../cn-demo-assets//Logo.png" alt="" />
              </div>
              <div class="teacher__header__title">星学会的一句叮咛</div>
            </div>
            <div class="teacher__content" v-html="interpretation.Remind"></div>
          </div>

          <div class="astroCalendarDetail__interpretation">
            <div class="interpretation__header">
              <div class="interpretation__header__pic">
                <img src="@/assets/共時曆/共時曆解讀星.svg" alt="" />
              </div>
              <div class="interpretation__header__title">星学会解读</div>
            </div>
            <div
              class="interpretation__content"
              v-html="interpretation.Interpretation"
            ></div>
          </div>
          <div class="astroCalendarDetail__events">
            <div
              class="astroCalendarDetail__events__item"
              v-for="(item, index) in calendarDailyList"
              :key="index"
              @click="showCalendarAstrolabePopup(item)"
            >
              <div
                class="astroCalendarDetail__events__item__dot"
                :class="{
                  isMoonDied: TYPE_MAP[item.Type] === '月空亡',
                  isRetrograde: TYPE_MAP[item.Type] === '逆行',
                  isEnterSign: TYPE_MAP[item.Type] === '進入星座',
                }"
              ></div>
              <div class="astroCalendarDetail__events__item__time">
                {{ moment(item.StartedAt).format("HH:mm") }}
              </div>
              <div class="astroCalendarDetail__events__item__title">
                {{ item.Title }}
              </div>
            </div>
          </div>
          <div class="astroCalendarDetail__goToNote" v-if="!theDayNote">
            <div
              class="astroCalendarDetail__goToNote__btn"
              @click="addAstroCalendarNoteHandler"
            >
              写下今日的笔记吧
            </div>
          </div>
          <div class="astroCalendarDetail__theDayNote" v-else>
            <AstroCalendarNoteCard
              :note="theDayNote"
              :nowloginPlatform="nowloginPlatform"
              @edit="editMoonNoteHandler"
              @delete="deleteMoonNoteHandler"
              @detail="toDetail"
            ></AstroCalendarNoteCard>
          </div>
        </div>
      </div>
      <!-- Tab 2 參數 -->
      <AstroCalendarParm
        v-if="showType === 'parm'"
        :filterOptionList="filterOptionList"
        :currentMonthEventsAll="currentMonthEventsAll"
      >
      </AstroCalendarParm>
      <!-- Tab 3 筆記 -->
      <div class="astroCalendar__main__note" v-if="showType === 'note'">
        <AstroCalendarNoteList
          v-if="noteReady && selectedDate"
          :selectedDate="selectedDate"
        ></AstroCalendarNoteList>
      </div>
    </div>
    <CalendarAstrolabePopup
      v-if="calendarAstrolabeObj"
      :calendarAstrolabeObj="calendarAstrolabeObj"
      @close="calendarAstrolabeObj = null"
    />
  </div>
</template>

<script>
import Calendar from "@toast-ui/calendar";
import { CALENDARS_TYPE, TYPE_MAP } from "@/js/calendar-type.js";
import "@toast-ui/calendar/dist/toastui-calendar.min.css";
import CalendarAstrolabePopup from "@/components/共時曆/CalendarAstrolabePopup.vue";
import Tab from "@/components/UI/Tab.vue";
import AstroCalendarParm from "@/components/共時曆/AstroCalendarParm.vue";
import AstroCalendarNoteList from "@/components/共時曆/AstroCalendarNoteList.vue";
import AstroCalendarNoteCard from "@/components/共時曆/AstroCalendarNoteCard";

import moment from "moment";
export default {
  components: {
    CalendarAstrolabePopup,
    Tab,
    AstroCalendarParm,
    AstroCalendarNoteList,
    AstroCalendarNoteCard,
  },
  data() {
    return {
      TYPE_MAP,
      moment,
      sourceData: [], //原始API資料
      calendar: null,
      calendarMonthTitle: "2026",
      calendarAstrolabeObj: null,
      calendarDailyList: [],

      selectedDate: "", // 目前選中的日期
      events: [],
      showType: "calendar",
      tabList: [
        { label: "月曆", value: "calendar" },
        { label: "參數", value: "parm" },
        { label: "筆記", value: "note" },
      ],
      filterOptionList: [],
      interpretation: {},
      noteReady: false,
      theDayNote: null, // 當天的筆記
      constellation: [
        { name: "牡羊", img: require("@/assets/constellations/con_1.svg") },
        { name: "金牛", img: require("@/assets/constellations/con_2.svg") },
        { name: "雙子", img: require("@/assets/constellations/con_3.svg") },
        { name: "巨蟹", img: require("@/assets/constellations/con_4.svg") },
        { name: "獅子", img: require("@/assets/constellations/con_5.svg") },
        { name: "處女", img: require("@/assets/constellations/con_6.svg") },
        { name: "天秤", img: require("@/assets/constellations/con_7.svg") },
        { name: "天蠍", img: require("@/assets/constellations/con_8.svg") },
        { name: "射手", img: require("@/assets/constellations/con_9.svg") },
        { name: "摩羯", img: require("@/assets/constellations/con_10.svg") },
        { name: "水瓶", img: require("@/assets/constellations/con_11.svg") },
        { name: "雙魚", img: require("@/assets/constellations/con_12.svg") },
      ],
      isCollapsed: true, // 預設收合（一週）
      ready: false,
      _cellClickHandlers: [], // 儲存 cell click handler 參考，避免重複綁定
    };
  },
  async created() {
    // 初始化時，預設顯示月曆
    this.$store.commit("setLoading_force", true);
    if (!this.hasEligibleProduct) {
      let productId = this.$store.getters.productListMap["Calendar2026"];
      this.$router.replace(`/store/detail/${productId}`);
      this.$store.commit("setLoading_force", false);
      return;
    }
  },
  async mounted() {
    if (!this.hasEligibleProduct) return;
    // 取得初始日期：優先採用網址上的 query `date`
    const queryDate = this.$route.query.date;
    const isValidQueryDate =
      typeof queryDate === "string" &&
      moment(queryDate, "YYYY-MM-DD", true).isValid();

    // 檢查日期是否在允許的範圍內 (2026/04/01 ~ 2026/06/30)
    const isDateAllowed =
      isValidQueryDate &&
      moment(queryDate).isBetween("2026-03-31", "2026-07-01", "day", "()");

    const baseDate = isDateAllowed ? new Date(queryDate) : new Date();
    this.selectedDate = moment(baseDate).format("YYYY-MM-DD");
    this.noteReady = true;
    this.$nextTick(async () => {
      this.initCalendar();
      // 初次載入讓日曆顯示到選定月份
      if (this.calendar) {
        this.calendar.setDate(this.selectedDate);
        const day = this.calendar.getDate();
        this.calendarMonthTitle =
          day.getFullYear() + "年" + (day.getMonth() + 1) + "月";
      }

      const start = new Date(
        baseDate.getFullYear(),
        baseDate.getMonth() - 1,
        23
      );
      const end = new Date(baseDate.getFullYear(), baseDate.getMonth() + 1, 7);
      const startFormat = moment(start).format("YYYY-MM-DD");
      const endFormat = moment(end).format("YYYY-MM-DD");
      await this.getCalendarData(startFormat, endFormat, this.selectedDate);
      this.updateCalendarDailyList();
      this.$store.commit("setLoading_force", false);
    });
  },
  computed: {
    hasEligibleProduct() {
      return this.$store.state?.userData?.CalendarInfo?.IsOwned2026;
    },
    currentMonthEventsAll() {
      if (!this.selectedDate) return [];
      const currentMonth = moment(this.selectedDate).month();
      const currentYear = moment(this.selectedDate).year();
      let currentMonthEvents = this.events
        .filter((event) => {
          let eventStartDate = moment(event.start);
          let eventEndDate = moment(event.end);
          return (
            (eventStartDate.month() === currentMonth &&
              eventStartDate.year() === currentYear) ||
            (eventEndDate.month() === currentMonth &&
              eventEndDate.year() === currentYear)
          );
        })
        .map((event) => {
          let eventStart = new Date(event.start);
          let formatter = new Intl.DateTimeFormat("zh-TW", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
            hour12: false,
          });
          return {
            ...event,
            start: formatter.format(eventStart),
            end: formatter.format(new Date(event.end)),
          };
        });
      return currentMonthEvents;
    },
    nowloginPlatform() {
      return localStorage.loginMethods;
    },
    topicImg() {
      if (!this.interpretation || !this.interpretation.Highlight) {
        return require("@/assets/constellations/con_1.svg");
      }
      let target = this.constellation.find((item) =>
        this.interpretation.Highlight.includes(item.name)
      );
      return target ? target.img : require("@/assets/constellations/con_1.svg");
    },
  },
  methods: {
    normalizeEventTitle(title) {
      if (!title || typeof title !== "string") return title;
      const compactTitle = title.replace(/\s+/g, "");
      if (!compactTitle.includes("@")) return title;

      const [prefix, ...rest] = compactTitle.split("@");
      const suffix = rest.join("@");
      if (!suffix) return compactTitle;

      const chunks = [];
      for (let i = 0; i < suffix.length; i += 2) {
        chunks.push(suffix.slice(i, i + 2));
      }

      const dedupedChunks = chunks.filter((chunk, index) => {
        if (!chunk) return false;
        if (index === 0) return true;
        return chunk !== chunks[index - 1];
      });

      return `${prefix}@${dedupedChunks.join("")}`;
    },
    async preMonth(targetDate) {
      // 判斷日期
      let oldDate = moment(this.calendar.getDate().d.d);
      const startDate = moment("2026-05-01");
      if (oldDate.isBefore(startDate, "month")) {
        this.$messagePopup(
          "該月份沒有共時曆內容",
          "2026 年共時曆僅收錄 4～12 月，<br>1～3 月沒有對應的內容喔。",
          "瞭解"
        );
        return;
      }

      let oldMoon = this.calendar.getDate().getMonth();
      let oldYear = this.calendar.getDate().getFullYear();
      let newMonth = oldMoon <= 0 ? 11 : oldMoon - 1;
      let newYear = oldMoon <= 0 ? oldYear - 1 : oldYear;
      this.calendarMonthTitle = newYear + "年" + (newMonth + 1) + "月";
      let start = new Date(newYear, newMonth - 1, 23);
      let end = new Date(newYear, newMonth + 1, 7);
      let startFormat = moment(start).format("YYYY-MM-DD");
      let endFormat = moment(end).format("YYYY-MM-DD");

      try {
        let newFocusDay = targetDate
          ? moment(targetDate)
          : moment(new Date(newYear, newMonth, 1)).format("YYYY-MM-DD");
        await this.getCalendarData(startFormat, endFormat, newFocusDay);
        this.selectedDate = newFocusDay;
        this.calendar.setDate(newFocusDay);
        setTimeout(() => {
          this.initDateGridEvents(newFocusDay);
        }, 50);
      } catch (error) {
        console.error("Error fetching calendar data:", error);
      }
    },
    async nextMonth(targetDate) {
      // 判斷日期
      let oldDate = moment(this.calendar.getDate().d.d);
      const endDate = moment("2026-05-01");
      if (oldDate.isAfter(endDate, "month")) {
        this.$messagePopup(
          "該月份內容準備中！",
          "2026 年共時曆 7～9 月及 10～12 月<br class='hidden-mobile-up'>的內容<br class='hidden-mobile-down'>會分兩批上架，敬請期待。",
          "瞭解"
        );
        return;
      }

      // this.calendar.next();
      let oldMoon = this.calendar.getDate().getMonth();
      let oldYear = this.calendar.getDate().getFullYear();
      let newMonth = oldMoon >= 11 ? 0 : oldMoon + 1;
      let newYear = oldMoon >= 11 ? oldYear + 1 : oldYear;

      this.calendarMonthTitle = newYear + "年" + (newMonth + 1) + "月";
      let start = new Date(newYear, newMonth - 1, 23);
      let end = new Date(newYear, newMonth + 1, 7);
      let startFormat = moment(start).format("YYYY-MM-DD");
      let endFormat = moment(end).format("YYYY-MM-DD");

      try {
        let newFocusDay = targetDate
          ? moment(targetDate)
          : moment(new Date(newYear, newMonth, 1)).format("YYYY-MM-DD");
        await this.getCalendarData(startFormat, endFormat, newFocusDay);
        this.selectedDate = newFocusDay;
        this.calendar.setDate(newFocusDay);
        setTimeout(() => {
          this.initDateGridEvents(newFocusDay);
        }, 50);
      } catch (error) {
        console.error("Error fetching calendar data:", error);
      }
    },
    displayEvents(newFocusDay) {
      if (!this.calendar) return;
      this.calendar.clear();

      //顯示星象重要程度調整 (星體逆行 > 新月(許願日)/ 滿月/ 日蝕/ 月蝕 > 星體 & 太陽月亮移位)
      const priorityMap = {
        逆行: 3, // 最優先：逆行
        新月: 2, // 第二順位：月相/蝕相
        滿月: 2,
        日蝕: 2,
        月蝕: 2,
        進入星座: 1, // 第三順位：移動
      };

      let showCategories = ["逆行", "滿月", "新月", "月蝕", "日蝕", "進入星座"];
      let showEvent = this.events
        .filter((event) => {
          return showCategories.includes(event.calendarId); // 不顯示發生相位的事件
        })
        .sort((a, b) => {
          // 由大到小排列 (權重高的會在陣列前面，優先被顯示)
          const weightA = priorityMap[a.calendarId] || 0;
          const weightB = priorityMap[b.calendarId] || 0;
          return weightB - weightA;
        })
        .map((event) => {
          return {
            ...event,
            title: this.normalizeEventTitle(event.title)
              .replace(/\s*進入\s*/, "→") // 將 "進入" 替換為 "→"
              .replace(/\s+/g, "") // 移除多餘的空白
              // .replace(/天王星/g, "♅ ") // 將 "天王星" 替換為 "♅"
              // .replace(/海王星/g, "♆ ") // 將 "海王星" 替換為 "♆"
              // .replace(/冥王星/g, "♇ ") // 將 "冥王星" 替換為 "♇"
              .replace(/天王星/g, "天王") // 將 "天王星" 替換為 "♅"
              .replace(/海王星/g, "海王") // 將 "海王星" 替換為 "♆"
              .replace(/冥王星/g, "冥王") // 將 "冥王星" 替換為 "♇"
              .replace(/@/g, (match, offset, string) => {
                return string.includes("逆行") ? "" : match; // 如果文字中包含 "逆行"，才替換 "@" 為空字串
              })
              .replace(/逆行/g, "℞"), // 將 "逆行" 替換為 "℞",
          };
        });
      this.calendar.createEvents(showEvent);
      this.initDateGridEvents(newFocusDay); // 為每個date grid添加事件
    },
    parseTime(source) {
      let date = new Date(source);
      let hours = date.getHours();
      let minutes = date.getMinutes();
      return `${hours}:${minutes < 10 ? "0" : ""}${minutes}`;
    },
    async getCalendarData(StartDate, EndDate, newFocusDay) {
      try {
        let res = await this.$API.GET_BOOK_CALENDAR(StartDate, EndDate);
        this.sourceData = res.data.Data;
        const targetMonth = moment(newFocusDay || this.selectedDate).format(
          "YYYY-MM"
        );

        let set = new Set();

        // 取得全部事件
        let allEvents = [];
        const uniqueEvents = [];
        const seen = new Set();
        for (let i = 0; i < this.sourceData.length; i++) {
          allEvents = allEvents.concat(this.sourceData[i].Details);
        }

        for (const event of allEvents) {
          const key = `${event.Title}|${event.StartedAt}`;
          if (!seen.has(key)) {
            seen.add(key);
            uniqueEvents.push(event);
          }
        }
        this.events = uniqueEvents.map((item) => {
          const typeLabel = TYPE_MAP[item.Type];

          // if (typeLabel == "逆行") {
          //   console.log("逆行事件", item);
          // }
          // if (typeLabel == "順行") {
          //   console.log("順行事件", item);
          // }

          if (
            typeLabel &&
            moment(item.StartedAt).format("YYYY-MM") === targetMonth
          ) {
            set.add(typeLabel);
          }

          return {
            calendarId: typeLabel,
            title: this.normalizeEventTitle(item.Title),
            isReadOnly: false,
            isAllday: false,
            category: "allday", //time, allday, task
            start: item.StartedAt,
            end: item.EndedAt,
          };
        });
        this.displayEvents(newFocusDay);

        this.filterOptionList = Array.from(set).map((item) => {
          return {
            label: item,
            value: item,
          };
        });
      } catch (e) {
        console.error(e);
      }
    },
    changeTabHandler($event) {
      if (this.showType === $event) return;
      this.$router.push({
        query: {
          ...this.$route.query,
          tab: $event,
        },
      });
    },
    async getInterpretationData() {
      try {
        let res = await this.$API.GET_CALENDAR_INTERPRETATION(
          moment(this.selectedDate).format("YYYY-MM-DD")
        );
        this.interpretation = res.data.Data;
      } catch (e) {
        console.error(e);
      }
    },
    async addAstroCalendarNoteHandler() {
      this.$store.commit("setAstroCalendarNoteEdit", {
        CalendarNoteId: "",
        Content: "",
        MoodContent: "",
        Date: moment(this.selectedDate).format("YYYY-MM-DD"),
        Title: this.interpretation.Title,
      });
      this.$router.push("/astroCalendar/note/create");
    },
    showCalendarAstrolabePopup(event) {
      this.calendarAstrolabeObj = {
        calendarId: TYPE_MAP[event.Type],
        title: this.normalizeEventTitle(event.Title),
        start: event.StartedAt,
        end: event.EndedAt,
      };
    },
    //為每個date grid添加事件
    initDateGridEvents(newFocusDay) {
      if (!this.calendar) return;

      const start = this.calendar.getDateRangeStart(); // 第一格（左上）顯示的日期
      const end = this.calendar.getDateRangeEnd(); // 最後一格（右下）顯示的日期

      // 產生從 start 到 end 的所有日期字串
      const dateList = [];
      const current = new Date(start);
      while (current <= end) {
        dateList.push(moment(current).format("YYYY-MM-DD"));
        current.setDate(current.getDate() + 1);
      }
      // console.log("dateList", dateList);
      const cells = document.querySelectorAll(".toastui-calendar-daygrid-cell");

      // 移除舊的 click handler，避免重複綁定造成指數級觸發
      if (!this._cellClickHandlers) this._cellClickHandlers = [];
      this._cellClickHandlers.forEach(({ cell, handler }) => {
        cell.removeEventListener("click", handler);
      });
      this._cellClickHandlers = [];

      cells.forEach((cell, index) => {
        if (index < dateList.length) {
          cell.setAttribute("data-date", dateList[index]);
        }

        // 點擊事件
        const handler = () => {
          const clickedDateStr = cell.getAttribute("data-date");
          if (clickedDateStr) {
            const clickedDate = new Date(clickedDateStr);
            const currentYear = this.calendar.getDate().getFullYear(); // 當前年份
            const currentMonth = this.calendar.getDate().getMonth() + 1; // 當前月份
            const clickedYear = clickedDate.getFullYear(); // 點擊的日期的年份
            const clickedMonth = clickedDate.getMonth() + 1; // 點擊的日期的月份

            if (
              clickedYear > currentYear ||
              (clickedYear === currentYear && clickedMonth > currentMonth)
            ) {
              // 如果是下一個月的日期
              this.nextMonth(clickedDateStr);
            } else if (
              clickedYear < currentYear ||
              (clickedYear === currentYear && clickedMonth < currentMonth)
            ) {
              // 如果是上個月的日期
              this.preMonth(clickedDateStr);
            } else {
              this.selectedDate = clickedDateStr; // 更新選中的日期
              this.calendar.setDate(clickedDateStr); // 先不要 會跑位

              // 1. 移除頁面上所有標註
              document
                .querySelectorAll(
                  ".toastui-calendar-weekday-grid-date-decorator"
                )
                .forEach((el) =>
                  el.classList.remove(
                    "toastui-calendar-weekday-grid-date-decorator"
                  )
                );

              // 2. 在這個 cell 裡找到 weekday-grid-date，加上 class
              const dateEl = cell.querySelector(
                ".toastui-calendar-weekday-grid-date"
              );
              if (dateEl) {
                dateEl.classList.add(
                  "toastui-calendar-weekday-grid-date-decorator"
                );
              }
            }
          }
        };
        cell.addEventListener("click", handler);
        this._cellClickHandlers.push({ cell, handler });
      });

      if (newFocusDay) {
        document
          .querySelectorAll(".toastui-calendar-weekday-grid-date-decorator")
          .forEach((el) =>
            el.classList.remove("toastui-calendar-weekday-grid-date-decorator")
          );
        // 3. 找到 newFocusDay 的 cell，並加上 class
        const focusCell = Array.from(cells).find((cell) => {
          return (
            cell.getAttribute("data-date") ===
            moment(newFocusDay).format("YYYY-MM-DD")
          );
        });
        if (focusCell) {
          const dateEl = focusCell.querySelector(
            ".toastui-calendar-weekday-grid-date"
          );
          if (dateEl) {
            dateEl.classList.add(
              "toastui-calendar-weekday-grid-date-decorator"
            );
          }
        }
      }
    },
    // 取得當天的筆記
    async getTheDayNote() {
      let Year = moment(this.selectedDate).format("YYYY");
      let Month = moment(this.selectedDate).format("MM");
      let { data } = await this.$API.GET_CalendarNoteList({
        Year: Year * 1,
        Month: Month * 1,
        OrderWay: "DESC",
        PageSize: 31,
        PageIndex: 1,
      });
      let target = data.Data.Datas.find((item) => {
        return (
          moment(item.Date).format("YYYY-MM-DD") ===
          moment(this.selectedDate).format("YYYY-MM-DD")
        );
      });
      this.theDayNote = target ? target : null;
    },
    editMoonNoteHandler(noteObj) {
      this.$router.push(`/astroCalendar/note/edit/${noteObj.CalendarNoteId}`);
    },
    deleteMoonNoteHandler(noteObj) {
      this.$messagePopup(
        "刪除筆記",
        "確定要刪除該筆記嗎？",
        "刪除",
        async () => {
          try {
            let { data } = await this.$API.DELETE_CalendarNote(
              noteObj.CalendarNoteId
            );
            if (data.Result) {
              this.$store.commit("update_toast", ["刪除成功"]);
              this.getTheDayNote();
            } else {
              this.$store.commit("update_toast", ["刪除失敗，請稍後再試"]);
            }
          } catch (error) {
            console.log(error);
            this.$store.commit("update_toast", ["刪除失敗，請稍後再試"]);
          }
        },
        true,
        true
      );
    },
    toDetail(item) {
      this.$router.push(`/astroCalendar/note/${item.CalendarNoteId}`);
    },
    initCalendar() {
      // 初始化日曆
      const container = document.getElementById("calendar");
      const options = {
        defaultView: "month",
        isReadOnly: true,
        calendars: CALENDARS_TYPE,
        month: {
          dayNames: ["日", "一", "二", "三", "四", "五", "六"],
          visibleWeeksCount: 1,
          workweek: false,
          narrowWeekend: false,
          startDayOfWeek: 0,
          isAlways6Weeks: false,
          visibleEventCount: 0,
        },
        theme: {
          common: {
            backgroundColor: "#19112B",
            border: "1px solid rgba(255, 255, 255, 0.2)",
            color: "#FFFFFF",
            dayName: {
              borderLeft: "0px solid #19112B",
              backgroundColor: "#19112B",
              color: "#FFFFFF",
            },
            holiday: { color: "#EE6DAF" },
            saturday: { color: "#FFFFFF" },
            weekend: {
              color: "#C084FC",
            },
            gridCell: {
              footerHeight: 31,
              color: "#FFFFFF",
            },
            today: {
              color: "#19112B",
              backgroundColor: "#EE6DAF",
            },
          },
          month: {
            dayExceptThisMonth: { color: "rgba(255, 255, 255, 0.45)" },
            holidayExceptThisMonth: { color: "rgba(255, 255, 255, 0.45)" },
            moreView: {
              backgroundColor: "#19112B",
              border: "1px solid rgba(255, 255, 255, 0.3)",
              color: "#FFFFFF",
            },
            moreViewTitle: {
              color: "#FFFFFF",
            },
            gridCell: {
              footerHeight: 31,
              color: "#FFFFFF",
            },
          },
        },
        //   useDetailPopup: true,
        template: {
          popupDetailTitle: function (data) {
            return "Detail of " + data.title;
          },
          time(event) {
            return `
          <span class="my-event-title">
          ${event.title}</span>`;
          },
          monthGridHeaderExceed: function (hiddenEvents) {
            return `<span class="hiddenEvents" style="font-size: 11px; display:none" >
            展開
            (${hiddenEvents})
            </span>`;
          },
        },
      };

      this.calendar = new Calendar(container, options);
      let day = this.calendar.getDate();
      this.calendarMonthTitle =
        day.getFullYear() + " " + (day.getMonth() + 1) + "月";
    },
    updateCalendarDailyList() {
      const targetDateStr = moment(this.selectedDate).format("YYYY-MM-DD");
      let target = this.sourceData.find((item) => {
        return moment(item.Date).format("YYYY-MM-DD") === targetDateStr;
      });
      this.calendarDailyList = target
        ? target.Details.filter(
            (detail) =>
              moment(detail.StartedAt).format("YYYY-MM-DD") === targetDateStr
          ).map((detail) => ({
            ...detail,
            Title: this.normalizeEventTitle(detail.Title),
          }))
        : [];
    },
    toggleCalendarCollapse() {
      this.isCollapsed = !this.isCollapsed;

      // 更新日曆的 visibleWeeksCount 和 visibleEventCount
      this.calendar.setOptions({
        month: {
          visibleWeeksCount: this.isCollapsed ? 1 : 0,
          visibleEventCount: this.isCollapsed ? 0 : 3,
        },
      });
      // 重新渲染日曆
      this.calendar.render();
      this.calendar.changeView("month");
      setTimeout(() => {
        this.initDateGridEvents(this.selectedDate);
      }, 50);
    },
  },
  watch: {
    "$route.query.tab": {
      handler(val) {
        const validTabs = ["calendar", "parm", "note"];
        if (validTabs.includes(val)) {
          setTimeout(() => {
            this.showType = val;
          }, 5);
          if (val === "calendar") {
            this.getTheDayNote();
          }
        } else {
          this.showType = "calendar";
        }
      },
      immediate: true,
    },
    selectedDate: {
      handler(newVal) {
        // 與網址 query `date` 同步
        const dateStr = moment(newVal).format("YYYY-MM-DD");
        if (this.$route.query.date !== dateStr) {
          this.$router.replace({
            query: {
              ...this.$route.query,
              date: dateStr,
            },
          });
        }

        // 1. 先把「選中日期」格式化成字串存起來，這樣後面比對比較快，不用一直呼叫 moment
        const targetDateStr = moment(newVal).format("YYYY-MM-DD");

        let target = this.sourceData.find((item) => {
          return moment(item.Date).format("YYYY-MM-DD") === targetDateStr;
        });

        // 2. 這裡加上 filter 邏輯
        // 如果有找到 target，就進去它的 Details 裡面過濾，看 StartedAt 是不是也是同一天
        this.updateCalendarDailyList();

        this.getInterpretationData(); // 取得解讀資料
        this.getTheDayNote(); // 取得當天的筆記
      },
      immediate: false,
    },
    // 可選：若使用者手動修改網址上的 date，連動更新 selectedDate
    "$route.query.date": {
      handler(val) {
        if (
          typeof val === "string" &&
          moment(val, "YYYY-MM-DD", true).isValid() &&
          moment(this.selectedDate).format("YYYY-MM-DD") !== val
        ) {
          this.selectedDate = val;
          if (this.calendar) {
            this.calendar.setDate(val);
            const day = this.calendar.getDate();
            this.calendarMonthTitle =
              day.getFullYear() + "年" + (day.getMonth() + 1) + "月";
          }
        }
      },
    },
  },
};
</script>

<style lang="scss">
@import "@/scss/_mixin.scss";

.astroCalendar {
  padding-top: 62px;
  width: 100%;
  max-width: 1160px;
  margin: 0 auto;
  min-height: 100vh;
  letter-spacing: 0.08em;
  @include pad {
    padding: 20px 24px 0;
  }
  @include mobile {
    padding: 0;
  }
  &__header {
    display: flex;
    align-items: center;
    margin: 0 32px;
    @include pad {
      flex-direction: column;
    }
    h2.st_title {
      font-weight: 500;
      font-size: 40px;
      color: $theme-color-2;
      display: flex;
      align-items: center;
      margin-right: auto;
      line-height: 1;
      @include laptop {
        display: none;
      }
      img {
        width: 54px;
        margin-right: 16px;
        @include pad {
          width: 30px;
          margin-right: 5px;
        }
      }
    }

    .filterBar {
      margin: 0 0 0;
      display: flex;
      justify-content: center;
      align-items: center;
      @include pad {
        margin-top: 24px;
      }
      input,
      input:focus {
        width: 300px;
        height: 36px;
        background: #f0f2f4;
        box-shadow: 2px 2px 4px rgba(238, 109, 175, 0.22), inset 2px 2px 4px rgba(0, 0, 0, 0.15);
        border-radius: 25px;
        outline: none;
        padding: 8px 46px;
        @include pad {
          max-width: 179px;
          height: 36px;
        }
      }
      input::placeholder {
        font-size: 14px;
        line-height: 20px;
        color: #d9d9d9;
      }
      label {
        position: relative;
        .serachIcon {
          position: absolute;
          left: 20px;
          top: 50%;
          transform: translateY(-50%);
        }
      }
      .filter_btn {
        @include btn-default(112px, 36px);
        border-radius: 100px;
        margin-left: 16px;
        @include pad {
          @include btn-default(72px, 36px);
        }
      }
      .addSynastrybtn {
        @include btn(40px, 40px, #ab956c, #fff, 12px);
        border-radius: 50%;
        margin-left: 30px;
        @include pad {
          margin-left: 20px;
        }
        img {
          width: 80%;
        }
      }
    }
  }
  &__main {
    width: 100%;
    max-width: 682px;
    margin: 0 auto;
    &__nav {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-bottom: 34px;
      gap: 74px;
      @include mobile {
        padding: 0 24px;
        margin-bottom: 16px;
        margin-top: 12px;
        gap: 0;
        justify-content: space-between;
      }
      &__prev,
      &__next {
        width: 32px;
        height: 32px;
        cursor: pointer;
        @include center;
        @include mobile {
          width: 16px;
          height: 16px;
        }
        img {
          width: 100%;
          height: 100%;
        }
      }
      &__date {
        color: #ab956c;
        font-size: 22px;
        font-weight: 700;
        @include mobile {
          font-size: 16px;
        }
      }
    }
    &__tab {
      @include mobile {
        padding: 0 24px;
      }
    }
    &__calendar {
      padding: 0 2px;
      background: $theme-color-3;
      margin-top: 24px;
      width: 100%;
      border-radius: 20px;
      box-shadow: 4px 4px 25px rgba(0, 0, 0, 0.3), -4px -4px 10px rgba(238, 109, 175, 0.22),
        -4px -4px 16px rgba(238, 109, 175, 0.22);
      padding: 40px;
      @include pad {
        padding: 20px;
      }
      @include mobile {
        margin-top: 12px;
        padding: 0;
        box-shadow: none;
      }
      #calendar {
        height: 650px;
        @include mobile {
          height: 600px;
        }
      }
      &__tips {
        font-size: 14px;
        font-weight: 400;
        line-height: 20px;
        color: $secondary-color-3;
        text-align: left;
        margin-top: 16px;
        @include mobile {
          font-size: 10px;
          margin-top: 0;
          margin-left: 24px;
        }
      }
      &__divider {
        margin-top: 16px;
        margin-bottom: 28px;
        height: 3px;
        background: #1f1633;
        -webkit-box-shadow: 4px 4px 10px 0px rgba(0, 0, 0, 0.08) inset,
          3px 3px 4px 0px rgba(238, 109, 175, 0.22);
        box-shadow: 4px 4px 10px 0px rgba(0, 0, 0, 0.08) inset,
          3px 3px 4px 0px rgba(238, 109, 175, 0.22);
        @include mobile {
          margin-top: 12px;
          margin-bottom: 16px;
        }
      }
      &__toggle {
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        margin-top: 24px;
        @include mobile {
          margin-top: 16px;
        }
        &__text {
          font-size: 14px;
          font-weight: 400;
          line-height: 20px;
          color: #a1a1a1;
          margin-right: 4px;
          @include mobile {
            font-size: 12px;
          }
        }
        &__img {
          width: 16px;
          height: 16px;
          padding-top: 4px;
          @include center;
          @include mobile {
            width: 12px;
            height: 12px;
          }
          img {
            height: 100%;
          }
          &.calendarIsCollapsed img {
            transform: rotate(180deg);
          }
        }
      }
    }
  }
  .tab .tab__item {
    @include mobile {
      font-size: 14px;
      height: 30px;
    }
  }
}

// astroCalendarDetail
.astroCalendarDetail {
  width: 100%;
  @include mobile {
    padding: 0 24px;
  }

  &__picArea {
    width: 96px;
    height: 96px;
    box-shadow: 4.75px 4.75px 11.88px 0px #00000033,
      -2.38px -2.38px 4.75px 0px rgba(238, 109, 175, 0.22), -2.38px -2.38px 4.75px 0px rgba(238, 109, 175, 0.22);

    border-radius: 50%;
    margin-bottom: 16px;
    margin: 0 auto;
    @include center;
    img {
      height: 80px;
      width: 80px;
      object-fit: cover;
      margin: 0 auto;
    }
    // 手機版微調
    @include mobile {
      width: 76px;
      height: 76px;
      img {
        width: 50px;
        height: 50px;
      }
    }
  }

  &__date {
    font-size: 22px;
    font-weight: 700;
    line-height: 28px;
    color: $secondary-color-1;
    margin-top: 16px;
    text-align: center;
    span {
      font-size: 16px;
      @include mobile {
        font-size: 14px;
      }
    }
    @include mobile {
      font-size: 18px;
      margin-top: 12px;
    }
  }

  &__highlight {
    margin-top: 8px;
    font-size: 20px;
    font-weight: 700;
    line-height: 24px;
    text-align: center;
    color: $secondary-color-1;
    @include mobile {
      margin-top: 4px;
      font-size: 16px;
      line-height: 24px;
    }
  }

  &__themes {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 12px;
    gap: 12px;
    @include mobile {
      margin-top: 8px;
      gap: 8px;
    }
    &__item {
      font-size: 14px;
      font-weight: 400;
      line-height: 20px;
      color: #798da5;
      padding: 4px 12px;
      background: #f0f2f4;
      border-radius: 6px;
      background-color: #f0f2f4;

      box-shadow: 4px 4px 10px 0px #00000014 inset, 2px 2px 4px 0px rgba(238, 109, 175, 0.22);

      @include mobile {
        font-size: 12px;
        padding: 2px 8px;
      }
    }
  }

  &__teacher {
    width: 100%;
    margin-top: 32px;
    margin-bottom: 20px;
    .teacher__header {
      display: flex;
      align-items: center;
      .teacher__header__pic {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        overflow: hidden;
        margin-right: 12px;
        @include mobile {
          width: 32px;
          height: 32px;
          margin-right: 8px;
        }
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
      .teacher__header__title {
        font-size: 16px;
        font-weight: 500;
        line-height: 28px;
        color: #ab956c;
        @include mobile {
          font-size: 14px;
        }
      }
    }
    .teacher__content {
      font-size: 16px;
      font-weight: 400;
      line-height: 28px;
      color: #868686;
      margin-top: 4px;
      text-align: left;
      // 手機版字體可能要大一點或行高調整
      @include mobile {
        font-size: 14px;
        line-height: 1.6;
      }
    }
  }
  &__interpretation {
    width: 100%;
    margin-top: 32px;
    margin-bottom: 20px;
    .interpretation__header {
      display: flex;
      align-items: center;
      .interpretation__header__pic {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        overflow: hidden;
        margin-right: 12px;
        @include mobile {
          width: 32px;
          height: 32px;
          margin-right: 8px;
        }
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
      .interpretation__header__title {
        font-size: 16px;
        font-weight: 500;
        line-height: 28px;
        color: #ab956c;
        @include mobile {
          font-size: 14px;
        }
      }
    }
    .interpretation__content {
      font-size: 16px;
      font-weight: 400;
      line-height: 28px;
      color: #868686;
      margin-top: 4px;
      text-align: left;
      // 手機版字體可能要大一點或行高調整
      @include mobile {
        font-size: 14px;
        line-height: 1.6;
      }
    }
  }

  &__content {
    font-size: 16px;
    color: #868686;
    text-align: center;
    margin-top: 22px;
    @include mobile {
      font-size: 14px;
      margin-top: 20px;
    }
  }
  &__events {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    gap: 16px 12px;
    margin-top: 30px;
    @include mobile {
      margin-top: 28px;
    }
    &__item {
      min-width: 48%;
      display: flex;
      align-items: center;
      cursor: pointer;
      &__dot {
        width: 10px;
        height: 10px;
        background-color: #808080;
        border: 1px solid #808080;
        border-radius: 50%;
        margin-right: 12px;
        @include mobile {
          width: 8px;
          height: 8px;
          margin-right: 8px;
        }
        &.isMoonDied {
          background-color: #ffffff;
          border-color: #9b9b9b;
        }
        &.isRetrograde {
          background-color: #e57d3c;
          border-color: #e57d3c;
        }
        &.isEnterSign {
          background-color: #41a88d;
          border-color: #41a88d;
        }
      }
      &__time {
        font-size: 14px;
        color: #868686;
        margin-right: 0.3em;
        @include mobile {
          font-size: 12px;
        }
      }
      &__title {
        font-size: 14px;
        color: #868686;
        text-decoration: underline;
        word-wrap: nowrap;
        @include mobile {
          font-size: 12px;
        }
      }
    }
  }
  &__goToNote {
    width: 100%;
    display: flex;
    justify-content: center;
    margin-top: 48px;
    &__btn {
      @include btn(189px, 30px, #f0f2f4, #868686, 16px);
      box-shadow: -1px -1px 4px 1px rgba(238, 109, 175, 0.22), 2px 2px 8px 0 rgba(0, 0, 0, 0.1);
      border-radius: 100px;
      text-align: center;
      @include mobile {
        @include btn(168px, 30px, #f0f2f4, #868686, 14px);
      }
    }
  }
  &__theDayNote {
    margin-top: 48px;
    @include mobile {
      margin-top: 24px;
    }
  }
}

// 套件CSS覆蓋
.toastui-calendar-grid-cell-more-events {
  //hiddenEvents
  @include mobile {
    position: absolute;
    bottom: 0;
    left: 0;
    z-index: 5;
  }
}

.toastui-calendar-see-more-container {
  z-index: 20 !important;
}
.toastui-calendar-weekday-event-title {
  font-size: 30px;
  font-weight: 400 !important;
}
.toastui-calendar-weekday-event-dot + .toastui-calendar-weekday-event-title {
  // color: #fff !important;
}
.toastui-calendar-see-more-header * {
  // color: #fff !important;
}

//事件包裝層
.toastui-calendar-weekday-event-block {
  // display: flex !important;
  // justify-content: center !important;
}
.toastui-calendar-day-name-item.toastui-calendar-month {
  text-align: center;
}

// 星期標題 - list
.toastui-calendar-day-names.toastui-calendar-month {
  margin-bottom: 20px;
  padding: 0 !important;
  @include mobile {
    margin-bottom: 0px;
    padding: 0 !important;
  }
}

// 星期標題 - item
.toastui-calendar-template-monthDayName {
  color: #c7d1e2 !important;
  font-size: 14px !important;
  font-weight: 600 !important;
  @include mobile {
    font-size: 12px !important;
  }
}

// 事件row
.toastui-calendar-weekday-events {
  top: 8px !important;
}

// 某天
.toastui-calendar-daygrid-cell {
  height: 80%;
  cursor: pointer;
  .toastui-calendar-grid-cell-date {
    transition: 0.2s;
  }
  .toastui-calendar-weekday-grid-date::before {
    content: "";
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: -1;
    width: 36px;
    height: 36px;
    border-radius: 50%;
    font-weight: bold;
    font-size: 14px;
    transition: 0.2s;
  }

  @include mobile-up {
    &:hover {
      .toastui-calendar-grid-cell-date {
        color: #fff !important;
      }
      :not(.toastui-calendar-weekday-grid-date-decorator).toastui-calendar-weekday-grid-date::before {
        content: "";
        display: inline-block;
        background-color: #afb9c5 !important;
        color: #fff !important;
        z-index: -1;
      }
    }
    &:active {
      .toastui-calendar-weekday-grid-date::before {
        content: "";
        background-color: #798da5 !important;
      }
    }
  }

  .hiddenEvents {
    color: #ffffff;
  }
}

// 某天 - 隔壁
.toastui-calendar-daygrid-cell + .toastui-calendar-daygrid-cell {
  border-left: none !important;
}

// 某天 - 顯示的日期
.toastui-calendar-grid-cell-header {
  text-align: center;
  font-size: 20px !important;
  font-weight: 700 !important;
  z-index: 1 !important;
  position: relative;
  @include mobile {
    font-size: 16px !important;
  }
}

.toastui-calendar-grid-cell-date {
  color: #ffffff !important;
  font-weight: 700 !important;
  text-shadow: 0 1px 4px rgba(0, 0, 0, 0.35);
}

// 某天 - 當天
.toastui-calendar-grid-cell-header button {
  display: none !important;
}

.toastui-calendar-weekday-grid-date-decorator {
  background-color: transparent !important;
  margin-left: 0 !important;
  position: relative !important;
  color: #fff;
  padding-left: 2px;
  font-weight: 400 !important;
  &::before {
    content: "";
    width: 36px;
    height: 36px;
    display: inline-block;
    background-color: #798da5 !important;
    color: #fff !important;
    border-radius: 50%;
    font-weight: bold;
    font-size: 14px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: -1;
    @include mobile {
      width: 28px !important;
      height: 28px !important;
      font-size: 14px !important;
    }
  }
}
// .toastui-calendar-daygrid-cell:has(
//     .toastui-calendar-weekday-grid-date-decorator
//   ) {
//   &::before {
//     content: "";
//     width: 36px;
//     height: 36px;
//     display: inline-block;
//     background-color: #798da5 !important;
//     color: #fff !important;
//     border-radius: 50%;
//     font-weight: bold;
//     font-size: 14px;
//     position: absolute;
//     top: 0;
//     left: 25px;
//     z-index: 0;
//     @include mobile {
//       width: 28px;
//       height: 28px;
//       font-size: 14px;
//     }
//   }

//   .toastui-calendar-weekday-grid-date-decorator {
//     // background-color: #798da5 !important;
//     background: transparent !important;
//   }
// }

// 事件-區間
.toastui-calendar-weekday-event-block {
  pointer-events: none !important;
}

.toastui-calendar-weekday-event-block:not(:has(.toastui-calendar-weekday-event-dot)) {
  padding: 0 8px !important;
  @include mobile {
    padding: 0 0px !important;
  }
  .toastui-calendar-weekday-event {
    width: 100% !important;
    height: auto !important;
    min-height: 20px;
    padding: 0 !important;
    margin: 0 !important;
    border-radius: 2px !important;
    border-left: unset !important;
    // border: 1px solid currentColor !important;
    font-weight: 400 !important;
    display: flex;
    align-items: center;
    justify-content: center;
    @include mobile {
      height: auto;
      min-height: 16px;
      padding: 0 !important;
    }
    .toastui-calendar-weekday-event-title {
      font-size: 13px !important;
      line-height: 13px !important;
      font-weight: 400 !important;
      padding: 0 !important; //事件內容主要padding
      letter-spacing: 0 !important;
      text-align: left !important;

      @include mobile {
        font-size: 12px !important;
        line-height: 16px !important;
      }
      @media (max-width: 420px) {
        font-size: 12px !important;
        line-height: 16zpx !important;
      }
      //讓字可以換行
      .toastui-calendar-template-allday {
        white-space: normal !important;
      }
    }
  }
}

// 事件-點
.toastui-calendar-weekday-event-block:has(.toastui-calendar-weekday-event-dot) {
  .toastui-calendar-weekday-event {
    font-size: 10px !important;
    color: Red !important;

    .toastui-calendar-weekday-event-title {
      font-size: 10px !important;
      color: Red !important;
    }
  }
}

//事件-非區間
.toastui-calendar-weekday-event-block:not(.toastui-calendar-weekday-exceed-left):not(.toastui-calendar-weekday-exceed-right) {
  @include mobile {
    display: flex;
    justify-content: center;
  }
  .toastui-calendar-weekday-event {
    @include mobile {
      max-width: 36px !important;
    }
  }
}

//收合時不顯示事件
.calendarIsCollapsed {
  .toastui-calendar-weekday-event-block {
    display: none !important;
  }
  &#calendar {
    height: 90px;
    @include mobile {
      height: 52px;
    }
  }
}

.toastui-calendar-floating-layer {
  display: none !important;
}
</style>
